export default __webpack_public_path__ + "device_floodlight_cam_wired_plus.f8834ea2.png";